import api from 'apis/config/api-service';

interface Restaurant {
  id: string | number;
  [key: string]: any;
}

interface Branch {
  id: string | number;
  [key: string]: any;
}

interface RestaurantParams {
  [key: string]: any;
}

interface MergeData {
  [key: string]: any;
}

interface AdminData {
  [key: string]: any;
}

interface EmailData {
  id: string | number;
  [key: string]: any;
}

interface BranchLinkData {
  [key: string]: any;
}

export default {
  getRestaurants: (params?: RestaurantParams) => api.get('restaurants', { ...params }),
  getRestaurantById: (id: string | number, params?: RestaurantParams) => api.get(`restaurants/${id}`, { ...params }),
  updateRestaurant: (restaurant: Restaurant) => api.patch(`restaurants/${restaurant.id}`, restaurant),
  getBranchById: (id: string | number) => api.get(`branches/${id}`),
  updateBranch: (branch: Branch) => api.patch(`branches/${branch.id}`, branch),
  getRestaurantUsers: (id: string | number, params?: RestaurantParams) =>
    api.get(`users?join=branches&filter=restaurantId||$eq||${id}&`, params),
  getRestaurantSuppliers: (resId: string | number, params?: RestaurantParams) =>
    api.get(`suppliers/restaurant/${resId}`, params),
  detachSupplier: (supplierId: string | number, restaurantId: string | number) =>
    api.patch(`suppliers/detach/${supplierId}/${restaurantId}`),
  attachSupplier: (supplierId: string | number, restaurantId: string | number) =>
    api.patch(`suppliers/attach/${supplierId}/${restaurantId}`),
  deleteRestaurantUser: (userId: string | number) => api.delete(`ums/v1/users/${userId}`),
  getRestaurantKpi: (restaurantId: string | number, params?: RestaurantParams) =>
    api.get(`reports/restaurants-kpis/${restaurantId}`, { ...params }),
  getRestaurantAdminManagersUsers: (id: string | number, params?: RestaurantParams) =>
    api.get(`branches/users/${id}`, params),
  getRestaurantBranches: (params?: RestaurantParams) => api.get(`branches`, { ...params }),
  getBranchSuppliers: (branchId: string | number, params?: RestaurantParams) =>
    api.get(`branches/${branchId}/suppliers`, { ...params }),
  changePreference: (data: any, params?: RestaurantParams) =>
    api.patch(`users/admin/update-preferences`, data, { ...params }),
  mergeRestaurants: (
    data: MergeData,
    holdingId: string | number,
    MergedId: string | number,
    params?: RestaurantParams
  ) => api.post(`restaurants/merge/${holdingId}/${MergedId}`, data, { ...params }),
  assignResAdmin: (data: AdminData, restaurantId: string | number, params?: RestaurantParams) =>
    api.post(`restaurants/restaurant-new-admin/${restaurantId}`, data, { ...params }),
  updateAdminInfo: (info: AdminData) => info.id && api.patch(`users/${info.id}`, info),
  selectResAdmin: (restaurantId: string | number, userId: string | number, params?: RestaurantParams) =>
    api.post(`restaurants/restaurant-new-admin/${restaurantId}/${userId}`, {}, { ...params }),
  getRestaurantOrdersList: (params?: RestaurantParams) => api.get('products', { ...params }),
  getRestaurantSupplierEmails: (resId: string | number, suppId: string | number, params?: RestaurantParams) =>
    api.get(`users/emails/cms/${resId}/${suppId}`, params),
  verifyEmailCC: (data: EmailData) => api.patch(`users/emails/cms/status/${data.id}`, data),
  attachDetachSupplierToBranch: (branchId: string | number, supplierId: string | number, data: BranchLinkData) =>
    api.patch(`branches/${branchId}/link/${supplierId}`, data),
};
